var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9289 3.59544C26.8043 1.72007 29.3478 0.666504 32 0.666504C34.6522 0.666504 37.1957 1.72007 39.0711 3.59544C40.9464 5.4708 42 8.01434 42 10.6665V31.9998C42 34.652 40.9464 37.1955 39.0711 39.0709C37.1957 40.9463 34.6522 41.9998 32 41.9998C29.3478 41.9998 26.8043 40.9463 24.9289 39.0709C23.0536 37.1955 22 34.652 22 31.9998V10.6665C22 8.01434 23.0536 5.4708 24.9289 3.59544ZM32 4.6665C30.4087 4.6665 28.8826 5.29865 27.7574 6.42386C26.6321 7.54908 26 9.0752 26 10.6665V31.9998C26 33.5911 26.6321 35.1173 27.7574 36.2425C28.8826 37.3677 30.4087 37.9998 32 37.9998C33.5913 37.9998 35.1174 37.3677 36.2426 36.2425C37.3679 35.1173 38 33.5911 38 31.9998V10.6665C38 9.0752 37.3679 7.54908 36.2426 6.42386C35.1174 5.29865 33.5913 4.6665 32 4.6665Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3335 24.6665C14.4381 24.6665 15.3335 25.5619 15.3335 26.6665V31.9998C15.3335 36.4201 17.0894 40.6593 20.215 43.785C23.3407 46.9106 27.5799 48.6665 32.0002 48.6665C36.4204 48.6665 40.6597 46.9106 43.7853 43.785C46.9109 40.6593 48.6668 36.4201 48.6668 31.9998V26.6665C48.6668 25.5619 49.5623 24.6665 50.6668 24.6665C51.7714 24.6665 52.6668 25.5619 52.6668 26.6665V31.9998C52.6668 37.481 50.4895 42.7376 46.6137 46.6134C42.738 50.4891 37.4813 52.6665 32.0002 52.6665C26.519 52.6665 21.2624 50.4891 17.3866 46.6134C13.5109 42.7376 11.3335 37.481 11.3335 31.9998V26.6665C11.3335 25.5619 12.2289 24.6665 13.3335 24.6665Z",
    fill: "#344054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 48.6665C33.1046 48.6665 34 49.5619 34 50.6665V61.3332C34 62.4377 33.1046 63.3332 32 63.3332C30.8954 63.3332 30 62.4377 30 61.3332V50.6665C30 49.5619 30.8954 48.6665 32 48.6665Z",
    fill: "#344054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3335 61.3335C19.3335 60.2289 20.2289 59.3335 21.3335 59.3335H42.6668C43.7714 59.3335 44.6668 60.2289 44.6668 61.3335C44.6668 62.4381 43.7714 63.3335 42.6668 63.3335H21.3335C20.2289 63.3335 19.3335 62.4381 19.3335 61.3335Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.2ed51ecf6e344fcf6836a0c846ff12e9.svg";
export { ForwardRef as ReactComponent };